<style lang="scss" scoped>
.header_logo {
  width: 50%;
  margin: 0 auto 40px;
}
img {
  display: block;
  width: 100%;
}
.pay_text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  .wxicon {
    width: 36px;
    margin-right: 10px;
  }
  .tip {
    font-size: 20px;
  }
}
.wxcode {
  margin: auto;
}
#login_container {
  margin-left: 80px;
  height: 225px;
}
// 微信二维码样式，需要base64转码
.impowerBox .title {
  display: none;
}
.impowerBox .info {
  display: none;
}
.impowerBox .qrcode {
  border-radius: 10px;
  width: 195px;
}
</style>
<template>
  <div>
    <el-dialog
      width="500px"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      append-to-body
      :before-close="closeInnerVisible"
      :close-on-click-modal="false"
    >
      <div class="header_logo">
        <img src="../assets/web/navbar-logo.png" />
      </div>
      <div class="wxcode">
        <div id="login_container"></div>
      </div>

      <div class="pay_text">
        <p class="wxicon">
          <img src="../assets/web/wxicon.png" />
        </p>
        <p class="tip">请打开微信扫码登录</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  props: {
    dialogVisible: Boolean,
  },
  data() {
    return {};
  },
  mounted() {
    // this.createScript('../../public/wx.js')
  },
  methods: {
    closeInnerVisible() {
      this.$parent.closeDialog();
    },
    paySuccess() {},
    getqrcode() {
      let host = window.location.origin;
      let path = this.$route.path;
      let redirectUrl = encodeURIComponent(host + "/#" + path);
      setTimeout(() => {
        var obj = new WxLogin({
          self_redirect: false,
          id: "login_container",
          appid: "wx24285ffbd9b63681",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent(
            host + "/official/oauth/wechat/callback?redirectUrl=" + redirectUrl
          ),
          state: "1211111",
          style: "black",
          href:
            "data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5pbmZvIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5xcmNvZGUgew0KICBib3JkZXItcmFkaXVzOiAxMHB4Ow0KICB3aWR0aDogMTk1cHg7DQp9",
        });
      }, 600);
    },
    createScript(url) {
      var scriptElement = document.createElement("script");
      document.body.appendChild(scriptElement);
      scriptElement.src = url;
    },
  },
};
</script>